import { useQuery } from '@tanstack/react-query'

import { getPaymentRequestEvidenceRecords } from '@src/api'
import { DefaultApiGetPaymentRequestEvidenceRecordsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchPaymentRequestEvidenceRecords = (
  params: DefaultApiGetPaymentRequestEvidenceRecordsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled:
      !!params.organizationId &&
      !!params.paymentRequestId &&
      !!params.evidenceId,
    queryFn: () => getPaymentRequestEvidenceRecords(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_PAYMENT_REQUEST_EVIDENCE_RECORDS,
      params.organizationId,
      params.paymentRequestId,
      params.evidenceId,
    ],
  })
}
